export function gatherAllDependenciesForExperience(expName: string, businessData: any): string[] {
  const visited = new Set<string>();
  const queue: string[] = [];

  const topLevel = businessData.releases.filter(
    (r: any) => (r.part_of_product || []).includes(expName)
  );
  topLevel.forEach((r: any) => {
    queue.push(r.name);
    visited.add(r.name);
  });

  while (queue.length > 0) {
    const currentName = queue.shift()!;
    const currentRelease = businessData.releases.find((r: any) => r.name === currentName);
    if (!currentRelease) continue;

    for (const dep of currentRelease.dependencies || []) {
      const depName = dep.name;
      if (!visited.has(depName)) {
        visited.add(depName);
        queue.push(depName);
      }
    }
  }

  return Array.from(visited);
}

export function gatherAllCheckedAndRequired(
  businessData: any,
  checkboxStates: Record<string, boolean>,
  deployedSet: Set<string>,
  skipQuota: boolean
): Set<string> {
  const finalSet = new Set<string>();

  for (const release of businessData.releases) {
    if (!checkboxStates[release.name]) continue;

    const queue = [release];
    while (queue.length) {
      const current = queue.shift()!;
      finalSet.add(current.name);

      if (skipQuota && deployedSet.has(current.name)) {
        continue;
      }

      for (const dep of current.dependencies || []) {
        const isUserChecked = !!checkboxStates[dep.name];
        if (skipQuota && deployedSet.has(dep.name)) continue;
        
        // Only include if user explicitly checked it
        // This ensures Step 2 selections are always in sync with Step 3
        if (isUserChecked) {
          if (!finalSet.has(dep.name)) {
            finalSet.add(dep.name);
            const depRelease = businessData.releases.find((r: any) => r.name === dep.name);
            if (depRelease) {
              queue.push(depRelease);
            }
          }
        }
      }
    }
  }

  return finalSet;
}

export function gatherAllForNonGranular(experiences: string[], businessData: any): string[] {
  const visited = new Set<string>();
  const results = new Set<string>();

  for (const exp of experiences) {
    const queue = businessData.releases
      .filter((r: any) => {
        const parts = r.part_of_product || []
        return parts.includes(exp) || parts.includes('*')
      })
      .map((r: any) => r.name)

    while (queue.length > 0) {
      const current = queue.shift()!;

      if (visited.has(current)) continue;
      visited.add(current);
      results.add(current);

      const rel = businessData.releases.find((r: any) => r.name === current);
      if (!rel) continue;

      for (const dep of rel.dependencies || []) {
        if (dep.required) {
          queue.push(dep.name);
        }
      }
    }
  }

  return Array.from(results);
}
